







































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Popup, Field, Loading, NoticeBar, Checkbox, Toast } from "vant";
import dataShare from "@/views/mall/dataShare";
import trainService from "@/service/trainService";
@Component({
  name: "trainAccount",
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [NoticeBar.name]: NoticeBar,
    [Checkbox.name]: Checkbox,
  },
})
export default class trainAccount extends Vue {
  // //data
  // dataShare = dataShare;
  isShowPopup = false;
  isAgreePolicy = false;
  errorTips = "";
  isShowVerify = false;
  isLoading = false;
  model = {
    OuterUserAct: "",
    OuterUserPwd: "",
    DigitCode: "",
    randcode: "",
    UniqueID: "",
  };
  accountList: {
    AccountID: "";
    OuterUserAct: "";
  }[] = [];

  // 失去焦点触发
  IdRules() {
    const regex = /^[a-zA-Z0-9]{4}$/;
    if (!regex.test(this.model.DigitCode)) {
      Toast("请输入身份证后四位");
      return;
    }
  }
  mounted() {
    sessionStorage.removeItem("loginOuterUserAct");
    this.loadData();
  }
  loadData() {
    trainService.accountList({}).then(json => {
      if (!json.isSucc) {
        return;
      }
      this.accountList = json.result?.entities! as any;
    });
  }
  //methods
  back() {
    history.back();
  }
  closePopup() {
    this.isShowPopup = false;
    if (this.isShowVerify) {
      this.isShowVerify = false;
      this.save();
    }
  }
  exit(id: string) {
    let __self = this;
    trainService.deleteAccount(id).then(json => {
      __self.loadData();
      __self.$dialog
        .alert({
          message: json.isSucc ? "退出登录成功" : json.message,
          closeOnPopstate: true,
        })
        .then(() => {});
    });
  }
  save() {
    let __self = this;
    if (!__self.isAgreePolicy) {
      __self.$dialog
        .alert({
          message: "请您同意我们的《账户授权协议》",
          closeOnPopstate: true,
        })
        .then(() => {});
      return;
    }
    // 输入框不允许为空
    if (this.model.OuterUserAct == "") {
      return Toast("请输入用户名");
    } else if (this.model.OuterUserPwd == "") {
      return Toast("请输入密码");
    } else if (this.model.DigitCode == "") {
      return Toast("请输入身份证后 4 位");
    }
    this.isLoading = true;
    this.model.UniqueID = this.$route.query.UniqueID as string;
    trainService.loginOuterUserAct(this.model).then(json => {
      __self.isLoading = false;

      if (!json.isSucc) {
        // json.statusCode = 234069;
        /* if(json.statusCode=="234069"){

        } */
        __self.model.randcode = "";
        __self.isShowPopup = true;
        __self.errorTips = __self.errorTips.replace("该账号需要手机发短信核验_", "");
        if (json.statusCode == "234069") {
          // 如果报错有234069就不显示 —— 发送短信提醒
          __self.isShowVerify = true;
        } else {
          __self.errorTips = json.message!;
          __self.isShowVerify = __self.errorTips.indexOf("发送短信666") > -1;
        }
        return;
      }
      sessionStorage.setItem("loginOuterUserAct", "success");
      history.back();
    });
  }

  maskCode(value?: string) {
    if (!value) return "";
    if (/^\d{17}[\dxX]$/.test(value)) return value.replace(/^(\d{4})\d{11}([\dxX]{3})$/gi, "$1***********$2");
    if (/^\d{11}$/.test(value)) return value.replace(/^(\d{3})\d{4}([\dxX]{4})$/gi, "$1****$2");
    if (/\d{4}-\d{2}-\d{2}/gi.test(value)) return value.replace(/^(\d{2})\d{2}-\d{2}-(\d{2})$/gi, "$1**-**-$2");
    if (/.+@\w+\.\w+/gi.test(value)) return value.replace(/(\w{1,3}).+@\w+\.(\w+)/gi, "$1**@**.$2");
    if (/^\w+\w{4}\w+$/.test(value)) return value.replace(/^(\w{1,3})\w+(\w{2})$/gi, "$1****$2");
    return value;
  }
}
